import styled from 'styled-components';

export const FieldIcon = styled.div`
  align-items: center;
  margin-left: 5px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
`;
